import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/embr/assets/images/embr.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", {
  class: "hidden lg:flex -ml-4 bal-text-color-changing flex items-center",
  style: {"font-family":"Pedrito","margin-right":"1.5rem"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "40",
    class: "-ml-4"
  }),
  /*#__PURE__*/_createTextVNode(" wavelength")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  class: "lg:hidden -ml-4 bal-text-color-changing flex items-center",
  style: {"font-family":"Pedrito"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "40",
    class: "-ml-4"
  }),
  /*#__PURE__*/_createTextVNode(" wave")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}